module.exports = __webpack_public_path__ + "26814b3437b40593b0525675879b8e2d.svg";